import { Card } from 'antd';
import { ReactNode } from 'react';
import './styles.less';
import { statusTagColors } from '@/components/_common/StatusTag/StatusTagColors';

export interface AgendaData {
  id: string;
  label: string;
  title: ReactNode;
  content: ReactNode;
  color: string;
  day: string;
  time: string;
}

interface Props {
  item: AgendaData;
}

export default function AgendaCard({ item }: Props) {
  const colors = statusTagColors[item.color];

  return (
    <Card
      className="agenda-card"
      style={{
        borderLeftColor: colors.borderColor,
        borderColor: colors.borderColor,
        backgroundColor: colors.backgroundColor,
      }}
      bodyStyle={{ padding: 8 }}
    >
      <div className="agenda-card-label" style={{ color: colors.color }}>
        {item.label}
      </div>
      <div className="agenda-card-title">{item.title}</div>
      <div className="agenda-card-content">{item.content}</div>
    </Card>
  );
}
